import { cn } from "cn";

export default function tw(
  ...classes: (string | false | null | undefined)[]
): string {
  return cn(...classes);
}
